import {
  getCribnoshDefaultAvatarUrl,
  getCribnoshAvatarUrl,
  normalizeCribnoshAvatarId,
  resolveCribnoshAvatarBaseUrl,
} from "@shared/avatars/defaultAvatars";

type LooseRecord = Record<string, unknown>;
const AVATAR_BASE_URL = resolveCribnoshAvatarBaseUrl(process.env);

function getString(value: unknown) {
  return typeof value === "string" && value.trim().length > 0 ? value.trim() : undefined;
}

function getFirstString(...values: unknown[]) {
  for (const value of values) {
    const candidate = getString(value);
    if (candidate) return candidate;
  }

  return undefined;
}

export function getProfileAvatarFallbackSrc() {
  return getCribnoshDefaultAvatarUrl(AVATAR_BASE_URL);
}

export function getProfileCribnoshAvatarId(profile?: LooseRecord | null) {
  if (!profile) return undefined;

  return normalizeCribnoshAvatarId(
    getFirstString(profile.cribnoshAvatarId, profile.avatar, profile.avatarId, profile.avatar_id),
  ) ?? undefined;
}

export function resolveAvatarCandidate(value: unknown) {
  const candidate = getString(value);
  if (!candidate) return undefined;

  const avatarId = normalizeCribnoshAvatarId(candidate);
  return avatarId
    ? getCribnoshAvatarUrl(avatarId, AVATAR_BASE_URL)
    : candidate;
}

export function getProfileAvatarSrc(profile?: LooseRecord | null) {
  if (!profile) return undefined;

  const cribnoshAvatarId = getProfileCribnoshAvatarId(profile);
  const avatarValue = getFirstString(profile.avatar);

  if (profile.avatarType === "cribnosh" && cribnoshAvatarId) {
    return getCribnoshAvatarUrl(cribnoshAvatarId, AVATAR_BASE_URL);
  }

  return (
    resolveAvatarCandidate(
      getFirstString(
        profile.avatar_url,
        profile.avatarUrl,
        profile.profilePicture,
        profile.profile_picture,
        profile.picture,
        profile.profileImage,
        profile.profileImageUrl,
        profile.profile_image,
        profile.profile_image_url,
        profile.imageUrl,
        profile.image_url,
        profile.image,
        profile.photoURL,
        profile.photoUrl,
        profile.photo_url,
        profile.requester_avatar_url,
      ),
    ) ??
    (avatarValue && !normalizeCribnoshAvatarId(avatarValue) ? avatarValue : undefined) ??
    (cribnoshAvatarId ? getCribnoshAvatarUrl(cribnoshAvatarId, AVATAR_BASE_URL) : undefined)
  );
}
